module.exports = {"421303001":"西城街道（）","421303002":"东城街道（）","421303003":"南郊街道（）","421303004":"北郊街道（）","421303005":"城南新区","421303101":"万店镇","421303102":"何店镇","421303103":"洛阳镇","421303104":"府河镇","421303187":"淅河镇","421303499":"曾都区新型工业基地","421303587":"随州市经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421303.json
// module id = 1789
// module chunks = 0